import { useState } from 'react';
import { SupplierSettingsApi } from '@/api/clients/supplier-settings/supplier-settings.api';

export const useUpdateSupplierSettings = () => {
  const [loading, setLoading] = useState(false);

  const updateSettings = async (organizationId, data) => {
    setLoading(true);
    try {
      return await SupplierSettingsApi.updateSettings(organizationId, data);
    } finally {
      setLoading(false);
    }
  };

  return { updateSettings, loading };
};
